export enum MultiMessageOperationEnum {
  add = 'Add',
  delete = 'Delete',
  update = 'Update',
}
